(function () {
  const EXPERIMENT_ID = 'cart-recommendations-ab';
  const CONTROL_GROUP = 'a';
  const EXPERIMENT_GROUP = 'b';
  const DEFAULT_GROUP = EXPERIMENT_GROUP;

  if (window.__fabriqueCartRecommendationsABInitialized) return;
  window.__fabriqueCartRecommendationsABInitialized = true;

  function getGroup(timeout) {
    return new Promise(resolve => {
      const startedAt = Date.now();

      function check() {
        try {
          const value = window._growthbook?.getFeatureValue?.(EXPERIMENT_ID, null);
          if (value !== null && value !== undefined && value !== '') {
            const group = String(value).toLowerCase();
            resolve(group === CONTROL_GROUP ? CONTROL_GROUP : DEFAULT_GROUP);
            return;
          }
        } catch (error) {
          resolve(DEFAULT_GROUP);
          return;
        }

        if (Date.now() - startedAt >= timeout) {
          resolve(DEFAULT_GROUP);
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function setExperimentMetadata(container, group) {
    container.querySelectorAll('.fabrique-product-wrapper, .card-product-small, [data-product-id], [data-handle]').forEach(card => {
      card.dataset.abExperimentId = EXPERIMENT_ID;
      card.dataset.abGroup = group;
      card.dataset.abVariant = group;
      card.dataset.abSlideFeatureId = EXPERIMENT_ID;
      card.dataset.trackAbtestExperimentId = EXPERIMENT_ID;
      card.dataset.trackAbtestExperimentGroup = group;
    });
  }

  function showGroup(module, group) {
    const control = module.querySelector('[data-cart-recommendations-control]');
    const experiment = module.querySelector('[data-cart-recommendations-experiment]');
    const active = group === EXPERIMENT_GROUP && experiment ? experiment : control;

    if (!active) return;

    const recommendationElement = active.querySelector(
      'cart-best-seller-recommendations, cart-b-recommendations',
    );

    if (!recommendationElement) {
      module.hidden = true;
      return;
    }

    if (control) control.hidden = active !== control;
    if (experiment) experiment.hidden = active !== experiment;
    module.hidden = false;
    module.dataset.abGroup = group;

    setExperimentMetadata(active, group);

    window.requestAnimationFrame(() => {
      active.querySelector('cart-best-seller-recommendations')?.renderRecommendations?.();
      const bRecommendations = active.querySelector('cart-b-recommendations');
      bRecommendations?.destroySlider?.();
      bRecommendations?.initSlider?.();
    });
  }

  if (!customElements.get('cart-recommendations-ab')) {
    class CartRecommendationsAB extends HTMLElement {
      connectedCallback() {
        getGroup(3000).then(group => {
          if (this.isConnected) showGroup(this, group);
        });
      }
    }

    customElements.define('cart-recommendations-ab', CartRecommendationsAB);
  }
})();
